<div class="container">
    <div class="title">
        <h1 class="main-heading">{{ 'rpe.vista-usuario.title' | translate }}</h1>
    </div>
    <div class="row">
        <rpe-entity-persona-form-container></rpe-entity-persona-form-container>
    </div>
</div>